import { useCallback, useState } from "react";
import {
  DrawerContentProps,
  DrawerData,
  DrawerProps,
  DrawerShowParams,
} from "../types";

export function useDrawer() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState<DrawerData>({
    children: null,
  });

  const [options, setOptions] = useState<
    Omit<DrawerProps, "onClose" | "isOpen" | "children">
  >({});
  const [contentProps, setContentProps] = useState<
    Omit<DrawerContentProps, "children">
  >({});

  const show = useCallback((params: DrawerShowParams) => {
    const { children, contentProps: newContentProps, ...options } = params;
    setData({
      children: children ?? null,
    });
    setOptions(options);
    newContentProps && setContentProps(newContentProps);
    setIsVisible(true);
  }, []);

  const hide = useCallback(() => {
    setIsVisible(false);
    setData({
      children: null,
    });
    setOptions({});
    setContentProps({});
  }, []);

  return {
    isVisible,
    show,
    hide,
    data,
    options,
    contentProps,
  };
}
